var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBelowArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4_54947)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.0781 64.4531H7.14526e-06V67.3828C7.14526e-06 72.2369 3.93497 76.1719 8.78907 76.1719H55.0781V64.4531ZM55.0781 82.0313H40.2344V88.2813H34.5334C33.9185 88.2812 33.3192 88.4747 32.8204 88.8343C32.3215 89.1938 31.9485 89.7012 31.7541 90.2846L29.801 96.144C29.1686 98.041 30.5807 100 32.5803 100H56.6547C55.6205 98.2206 55.0765 96.1988 55.0781 94.1406V82.0313ZM91.2109 7.35083e-06H8.78907C7.47787 -0.00169179 6.18303 0.291196 5.0002 0.857039L21.4844 17.3412V14.6484C21.4844 13.0305 22.7961 11.7188 24.4141 11.7188C26.032 11.7188 27.3438 13.0305 27.3438 14.6484V24.4141C27.3438 26.032 26.032 27.3438 24.4141 27.3438H14.6484C13.0305 27.3438 11.7188 26.032 11.7188 24.4141C11.7188 22.7961 13.0305 21.4844 14.6484 21.4844H17.3412L0.857038 5.00001C0.291218 6.18291 -0.00166799 7.47781 7.14526e-06 8.78907V58.5938H55.0781V43.3594C55.0781 36.8977 60.3352 31.6406 66.7969 31.6406H94.1406C96.1988 31.639 98.2206 32.183 100 33.2172V8.78907C100 3.93497 96.065 7.35083e-06 91.2109 7.35083e-06Z",
    fill: "url(#paint0_linear_4_54947)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.1406 37.5H66.7969C66.2721 37.5 65.7641 37.5699 65.2801 37.6994L79.4922 51.9115V49.2188C79.4922 47.6008 80.8039 46.2891 82.4219 46.2891C84.0398 46.2891 85.3516 47.6008 85.3516 49.2188V58.9844C85.3516 60.6023 84.0398 61.9141 82.4219 61.9141H72.6562C71.0383 61.9141 69.7266 60.6023 69.7266 58.9844C69.7266 57.3664 71.0383 56.0547 72.6562 56.0547H75.349L61.1369 41.8424C61.0044 42.3372 60.9374 42.8472 60.9375 43.3594V94.1406C60.9375 97.3768 63.5607 100 66.7969 100H94.1406C97.3768 100 100 97.3768 100 94.1406V43.3594C100 40.1232 97.3768 37.5 94.1406 37.5Z",
    fill: "url(#paint1_linear_4_54947)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_54947",
    x1: 0.00000175966,
    y1: 3.18112,
    x2: 121.875,
    y2: 117.187,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4_54947",
    x1: 60.9375,
    y1: 39.4882,
    x2: 127.464,
    y2: 78.3827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D09A85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#B971B2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A46A7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4_54947"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBelowArrow);
export default __webpack_public_path__ + "static/media/below_arrow.2c51090b6fe21e2f1114bcd38548b36a.svg";
export { ForwardRef as ReactComponent };